import React from 'react';


import * as FontAwesome from "react-icons/fa"
const Icon = ({ iconName, styles, click }) => {

    const icon = React.createElement(FontAwesome[iconName])
    return (<span onClick={click} className={styles}>{icon}</span>);
}

export default Icon;